
import { createContext, useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Header } from '../../components/Header';
import { Loading } from '../../components/Loading';
import { MainButton } from '../../components/MainButton';
import { Menu } from '../../components/Menu';
import { ConfigType } from '../../contexts/AppConfigContext';
import { OrderToSendType, CustomerType } from '../../contexts/OrderContext';
import { PluginspaceResponseType } from '../../contexts/PluginspaceContext';
import { floatToCents, floatToPrice } from '../../functions/price_functions';
import { useAppConfig } from '../../hooks/useAppConfig';
import { useOrder } from '../../hooks/useOrder';
import { usePluginspace } from '../../hooks/usePluginspace';
import api from '../../services/api';
import { v4 as uuidv4 } from 'uuid';
import './index.css';
import { cpfCnpjNoMask, datetimeToDatetimeBR } from '../../functions/mask';
import { useDiscount } from '../../hooks/useDiscount';

type PixGatewayType = {
    transactionId: string;
    amount: number;
    currency: string;
    expiresAt: string;
    link: string;
    processorTransactionId: string;
    processorName: string;
    message: string;
    processorMessage: string;
    errorReason: string | null;
    wallet: string;
}

type SkuStockType = {
    sku: string;
    name: string;
    context: string;
    inventory: number;
    minimumStock: number;
}

export function QRCodePayment() {
    const orderContext = useOrder();
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { getTotalValue,
        getFreight,
        getCustomer,
        getGatewayId,
        getPaymentType,
        synchronizeContextToStorage,
        generateDataToSendOrderCard,
        setReceipt,
        setOrderId,
        setOrderIdExt,
        clearOrder,
 
    } = useOrder();
    const { getAppConfig } = useAppConfig();
    const [config, setConfig] = useState<ConfigType | void>();
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [freight, setFreight] = useState(0);
    const [name, setName] = useState('');
    const { getToken, getThisPluginspace, registerAccess, pluginspace } = usePluginspace();
    const [qrCode, setQrCode] = useState('');
    const [qrCodeStatus, setQrCodeStatus] = useState('');
    const [qrCodeText, setQrCodeText] = useState('');
    const [processorTransactionId, setProcessorTransactionId] = useState('');
    const [nowDate, setNowDate] = useState(new Date().toISOString());
    const [timeoutItem, setTimeoutItem] = useState<any>(null)
    const [loadingHeader, setLoadingHeader] = useState(true);
    const [countVerify, setcountVerify] = useState(0);
    const useDiscountContext = useDiscount()

    useEffect(() => {
        registerAccess('order-qrcode')
        getConfig();
    }, []);

    async function generateQRCodeWallet(wallet: string, gatewayId: number, amount: number) {
        const customerStorage = await getCustomer();
        //Valida a existência do plano de pagamento informado no contexto do pedido
        if (orderContext && !Object.keys(orderContext).includes('integrationPlan')) {
            //Não localizou plano de pagamento no contexto do pedido
            setLoading(false)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Não foi possivel obter plano de pagamento, entre em contato com a loja, ou escolha outra forma de pagamento',
            })
        }
        if (wallet && gatewayId && customerStorage) {
            const pluginspaceData: void | PluginspaceResponseType = await getThisPluginspace();
            await api.post(`api/totvshub/paymentTotvsHub`, {
                pluginspaceId: pluginspaceData ? pluginspaceData.id : 0,
                gatewayId: gatewayId,
                customerId: customerStorage.id,
                email: customerStorage.email,
                wallet: wallet,
                amount: amount
            }, {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            })
                .then(async (responseWallet) => {
                    setLoading(false);
                    if (responseWallet.data.processorTransactionId) {
                        setProcessorTransactionId(responseWallet.data.processorTransactionId)

                        await preOrderPix(orderContext, responseWallet.data);

                    }
                    if (responseWallet.data.qrCode) {
                        setQrCode(responseWallet.data.qrCode)
                    }
                    if (responseWallet.data.qrCodeText) {
                        setQrCodeText(responseWallet.data.qrCodeText)
                    }

                    localStorage.setItem('qrcodePixPayment',
                        JSON.stringify({
                            type: 'wallet',
                            qrCode: responseWallet.data.qrCode,
                            qrCodeText: responseWallet.data.qrCodeText,
                            orderId: responseWallet.data.transactionId,
                            processorTransactionId: responseWallet.data.processorTransactionId,
                            expirationDate: responseWallet.data.expiresAt
                        })
                    )
                    verifyStatusQrcodeTotvs(
                        pluginspaceData ? pluginspaceData.id : 0,
                        gatewayId,
                        responseWallet.data.transactionId,
                        responseWallet.data.processorTransactionId,
                    )
                    /*
                    verifyStatusQrcode(
                        pluginspaceData ? pluginspaceData.id : 0,
                        gatewayId,
                        responseWallet.data.processorTransactionId,
                        responseWallet.data.processorName,
                        responseWallet.data.qrCodeText,
                        customerStorage,
                        responseWallet.data.message,
                        responseWallet.data.processorMessage
                    )*/
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                })
        } else {
            setLoading(false);
        }
    }

    async function preOrderPix(order: any, structTransaction: any) {
        if (order && structTransaction) {
            let preOrder = {
                transaction: structTransaction,
                order,
            }

            return await api.post('api/orders/sendPreOrder',
                {
                    preOrder,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${await getToken()}`
                    }
                }).then((response) => {
                    return response.data.data
                })
                .catch((err) => {
                    console.log(err);
                    return null;
                })
        }
    }

    //Usado ao finalizar o pagamento
    async function preOrderStatusPix(order: any, structTransaction: any) {
        if (order && structTransaction) {
            let preOrder = {
                transaction: structTransaction,
                order,
                status: structTransaction.status,
            }


            return await api.post('api/orders/preOrderStatusPix',
                {
                    preOrder,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${await getToken()}`
                    }
                }).then((response) => {
                    return response.data.data
                })
                .catch((err) => {
                    console.log(err);
                    return null;
                })
        }
    }

    //Usado quando o status é refuned, expired ou canceled
    async function preOrderStatusCanceled(transactionId: string, processorTransactionId: string, status: string) {
        if (transactionId && status) {
            let preOrderSchema = {
                transactionId: transactionId,
                processorTransactionId: processorTransactionId,
                status: status,
            }


            return await api.post('api/orders/preOrderStatusCanceled',
                {
                    transactionId,
                    processorTransactionId,
                    status,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${await getToken()}`
                    }
                }).then((response) => {
                    return response.data.data
                })
                .catch((err) => {
                    console.log(err);
                    return null;
                })
        }
    }

    async function verifyStatusQrcodeTotvs(
        pluginspaceId: number,
        gatewayId: number,
        orderId: string,
        processorTransactionId: string
    ) {
        setTimeoutItem(setTimeout(async () => {
            await api.post(`api/totvshub/statusPayTotvsHub`, {
                pluginspaceId,
                gatewayId,
                processorTransactionId,
            }, {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            })
                .then(async (responseWallet) => {
                    if (responseWallet.data.Dados && responseWallet.data.Dados.status && responseWallet.data.Dados.status === 'approved') {
                        setLoading(true);
                        const pluginspaceData = await getThisPluginspace()
                        await api.post(`api/orders/processQueuePreOrderByTranscactionId/${orderId}`,
                            {},
                            {
                                headers: {
                                    'Authorization': `Bearer ${await getToken()}`
                                }
                            }).then(async (response) => {
                                if (response.data && response.data.processed) {
                                    const objProcessed = response.data.processed[0]

                                    if (objProcessed) {
                                        if (objProcessed.update) {
                                            const orderData = objProcessed.data.data
                                            setOrderId(orderData.orderId);
                                            setOrderIdExt(orderData.orderidExt);
                                            setReceipt(orderData.customerReceipt.customer_receipt);

                                            await synchronizeContextToStorage();
                                            localStorage.removeItem("cupom");
                                            clearOrder();

                                            localStorage.removeItem('qrcodePixPayment');

                                            if (pluginspaceData?.type !== 'food') {
                                                navigate(`/${pluginspace_id}/new-success-order`);
                                            } else {
                                                navigate(`/${pluginspace_id}/success-order`);
                                            }

                                        } else {
                                            //Não possui o objeto processado
                                            setLoading(false)
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Erro',
                                                text: 'Não foi possível finalizar sua compra',
                                            })
                                        }

                                    } else {
                                        //Não localizou o objeto processado
                                        setLoading(false)
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Erro',
                                            text: 'Não foi possível finalizar sua compra',
                                        })
                                    }

                                } else {
                                    setLoading(false)
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Erro',
                                        text: 'Não foi possível finalizar sua compra',
                                    })
                                }

                            })
                    } else {
                        if (responseWallet.data.Dados &&
                            responseWallet.data.Dados.status &&
                            (responseWallet.data.Dados.status === 'expired' ||
                                responseWallet.data.Dados.status === 'refunded')) {
                            const status = responseWallet.data.Dados.status === 'expired' ? 'expirado' : 'cancelado'
                            const message = `QrCode está ${status}, não foi possível finalizar sua compra. Consulte na opção de pedidos para mais informações, caso tenha efetuado o pagamento no banco, caso contrário gere um novo QRCode, selecionando a opção 'SIM'`;
                            validateIfLocalStorage(responseWallet.data.Dados.status);
                            setLoading(false)
                            Swal.fire({
                                icon: 'warning',
                                title: 'Atenção',
                                text: message,
                                showCancelButton: true, // Adiciona o botão "Não"
                                confirmButtonText: 'Sim', // Texto para o botão "Sim"
                                cancelButtonText: 'Não', // Texto para o botão "Não"
                                timer: undefined, // Remove o timer para aguardar a interação do usuário
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Usuário clicou em "Sim"
                                    getConfig();
                                } else if (result.isDismissed) {
                                    // Usuário clicou em "Não" ou fechou o modal

                                    navigate(-1)
                                }
                            });
                        }
                        setTimeoutItem(setTimeout(async () => {
                            verifyStatusQrcodeTotvs(pluginspaceId, gatewayId, orderId, processorTransactionId);
                        }, 5000))
                    }
                })
                .catch((err) => {
                    console.log(err);
                    verifyStatusQrcodeTotvs(pluginspaceId, gatewayId, orderId, processorTransactionId)
                })
        }, 5000))
    }

    async function verifyStatusQrcode(
        pluginspaceId: number,
        gatewayId: number,
        processorTransactionId: string,
        processorName: string,
        link: string,
        customer: CustomerType,
        message: string,
        processorMessage: string,
    ) {
        setTimeoutItem(setTimeout(async () => {
            await api.post(`api/totvshub/statusPayTotvsHub`, {
                pluginspaceId,
                gatewayId,
                processorTransactionId,
            }, {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            })
                .then(async (responseWallet) => {
                    if (responseWallet.data.Dados && responseWallet.data.Dados.status && responseWallet.data.Dados.status === 'approved') {
                        setLoading(true);
                        const objGateway = {
                            transactionId: responseWallet.data.Dados.transactionId,
                            amount: floatToCents(responseWallet.data.Dados.amount.value),
                            currency: responseWallet.data.Dados.amount.currency,
                            expiresAt: responseWallet.data.Dados.expiresAt,
                            link: link,
                            processorTransactionId: responseWallet.data.Dados.processorTransactionId,
                            processorName: 'Totvs Pagamentos',
                            message: message,
                            processorMessage: processorMessage,
                            errorReason: null,
                            wallet: responseWallet.data.Dados.wallet
                        }
                        const encryptedData = await generateGatewayPix(objGateway);
                        const orderData: OrderToSendType | undefined = await generateDataToSendOrderCard(customer, encryptedData, uuidv4(), false, true, false);
                        if (orderData) {
                            const resultStock = await verifyStock(orderData);
                            if (resultStock) {
                                const resultPayment = await makePaymentPix(orderData);
                                setLoading(false);
                                if (resultPayment && resultPayment.success === true) {
                                    setOrderId(resultPayment.dados.orderId);
                                    setOrderIdExt(resultPayment.dados.orderidExt);
                                    setReceipt(resultPayment.dados.customerReceipt.customer_receipt);
                                    preOrderStatusPix(orderData, responseWallet.data);
                                    //passando os dados para atualizar o preorder
                                    preOrderStatusPix(orderData, responseWallet.data);

                                    navigate(`/${pluginspace_id}/receipt`);
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Erro',
                                        text: 'Não foi possível finalizar sua compra',
                                    })
                                }
                            }
                        } else {
                            setLoading(false)
                            Swal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: 'Não foi possível finalizar sua compra',
                            })
                        }
                    } else {
                        if (responseWallet.data.Dados &&
                            responseWallet.data.Dados.status &&
                            (responseWallet.data.Dados.status === 'expired' ||
                                responseWallet.data.Dados.status === 'refunded')) {
                            const status = responseWallet.data.Dados.status === 'expired' ? 'expirado' : 'cancelado'
                            const message = `QrCode está ${status}, não foi possível finalizar sua compra. Consulte na opção de pedidos mais informações, caso tenha efetuado o pagamento no banco`;
                            setLoading(false)
                            Swal.fire({
                                showCancelButton: true, // Adiciona o botão "Não"
                                confirmButtonText: 'Sim', // Texto para o botão "Sim"
                                cancelButtonText: 'Não', // Texto para o botão "Não"
                                timer: undefined, // Remove o timer para aguardar a interação do usuário
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Usuário clicou em "Sim"
                                    getConfig();
                                } else if (result.isDismissed) {
                                    // Usuário clicou em "Não" ou fechou o modal

                                }
                            });
                        }
                        verifyStatusQrcode(pluginspaceId, gatewayId, processorTransactionId, processorName, link, customer, message, processorMessage)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    verifyStatusQrcode(pluginspaceId, gatewayId, processorTransactionId, processorName, link, customer, message, processorMessage)
                })
        }, 5000))
    }

    async function generateGatewayPix(pixToEncrypt: PixGatewayType) {

        return await api.post('api/cryptography/encryptJson',
            {
                value: pixToEncrypt
            },
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then((response) => {
                return response.data.data.encryptedData
            })
            .catch((err) => {
                console.log(err);
                return null;
            })
    }

    async function makePaymentPix(orderData: OrderToSendType) {
        orderData.urlNotification = window.location.href.replace("order-qrcode", "success-order");
        return await api.post('api/orders/sendOrder',
            orderData,
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                return null;
            })
    }

    async function verifyStock(orderData: OrderToSendType) {
        const pgData = await getThisPluginspace();
        const config = await getAppConfig();
        if (config && !config.content.pdv.showOutStock) {
            return await api
                .post("/api/variations/sku-inventory", {
                    skus: orderData.products.map((product) => product.productSku),
                    locationId: orderData.locationId,
                    status: true
                }, {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                })
                .then((response) => {
                    const items = response.data;
                    if (items.data) {

                        let productsEmpty: SkuStockType[] = [];
                        items.data.forEach((item: SkuStockType) => {
                            const prod = orderData.products.find((product) => product.productSku === item.sku)
                            if (prod?.quantity && (item.inventory - item.minimumStock) < prod.quantity) {
                                productsEmpty.push(item);
                            }
                        })
                        if (productsEmpty && productsEmpty.length > 0) {
                            setLoading(false);
                            let textSwal = '';
                            productsEmpty.forEach((product: SkuStockType) => {
                                textSwal += `Produto: ${product.name} sem estoque<br/>`
                            });
                            Swal.fire({
                                icon: "warning",
                                html: textSwal
                            });
                            return false;
                        }
                        return true;
                    } else {
                        setLoading(false)
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Não foi possível obter estoque dos produtos',
                        })
                    }
                })
                .catch((err) => {
                    setLoading(false)
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Não foi possível obter estoque dos produtos',
                    })
                });
        } else {
            return true;
        }
    }

    async function validateCupomBefore() {
        try {
            const cupom = useDiscountContext.data.couponCode;
            if (cupom) {
                await validateDiscoutCoupon(cupom)

            }
        } catch (error) {
            console.log(error);
        }
    }

    async function validateDiscoutCoupon(coupon: string) {
        try {
            if (coupon) {
                const payload = {
                    nameCoupom: coupon,
                };

                const response = await api
                    .post("/api/discount-coupons/validCupons", payload, {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    })
                    .then(async (response) => {
                        if (response.data && response.data.success) {
                            return {
                                success: true,
                                data: response.data,
                            };
                        }
                        Swal.fire({
                            icon: 'warning',
                            title: 'Cupom inválido',
                            text: 'O cupom inserido não é mais válido. Você será redirecionado para a tela do carrinho para revisar suas compras.',
                        }).then(() => {
                            navigate(`/${pluginspace_id}/new-cart`);
                        });
                    })
                    .catch((err) => {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Cupom inválido',
                            text: 'O cupom inserido não é mais válido. Você será redirecionado para a tela do carrinho para revisar suas compras.',
                        }).then(() => {
                            navigate(`/${pluginspace_id}/new-cart`);
                        });
                    });

                return response;
            }
        } catch (error) {
            Swal.fire({
                icon: 'warning',
                title: 'Cupom inválido',
                text: 'O cupom inserido não é mais válido. Você será redirecionado para a tela do carrinho para revisar suas compras.',
            }).then(() => {
                navigate(`/${pluginspace_id}/new-cart`);
            });
            return {
                success: false,
                data: [],
            };
        }
    }

    async function loadOrder() {
        setLoading(true);
        await synchronizeContextToStorage();
        const customerStorage = await getCustomer();
        const totalValue = await getTotalValue();
        const freightStorage = await getFreight();
        const paymentTypeStorage = await getPaymentType();
        const gatewayIdStorage = await getGatewayId();
        await validateCupomBefore()

        setTotal(totalValue);
        setFreight(freightStorage);
        setName(customerStorage.name);

        // fazer validacao se existe as informacoes no localstorage

        const validateLocalStorage = await validateIfLocalStorage();

        if (validateLocalStorage.success) {
            setLoading(false);
            return;
        }



        if (paymentTypeStorage.includes('-wallet')) {
            await generateQRCodeWallet(paymentTypeStorage.split("-wallet")[0], gatewayIdStorage, totalValue + freightStorage)
        } else {
            await generateQrCodePagseguro(gatewayIdStorage, totalValue + freightStorage, customerStorage)
            setLoading(false);
        }

    }

    async function validateIfLocalStorage(qrCodeStatus?: string) {
        try {
            const hasInLocalStorage = localStorage.getItem('qrcodePixPayment');

            if (hasInLocalStorage) {
                const data: {
                    type: 'pagseguro' | 'wallet';
                    qrCode: string;
                    qrCodeText: string;
                    orderId: string;
                    processorTransactionId: string;
                    expirationDate: string;
                } = JSON.parse(hasInLocalStorage);

                if (qrCodeStatus === 'expired' || qrCodeStatus === 'refunded' || qrCodeStatus === 'canceled') {
                    localStorage.removeItem('qrcodePixPayment');
                    let message = qrCodeStatus === 'expired' ? 'O QRCode expirou' : 'O QRCode foi cancelado';
                    switch (qrCodeStatus) {
                        case 'expired':
                            message = 'O QRCode expirou';
                            break;
                        case 'refunded':
                            message = 'O QRCode foi cancelado';
                            break;
                        case 'canceled':
                            message = 'O QRCode foi cancelado';
                            break;
                        default:
                            break;
                    }

                    //if(qrCodeStatus === 'canceled'){
                    preOrderStatusCanceled(data.orderId, !data.processorTransactionId ? data.orderId : data.processorTransactionId, qrCodeStatus);
                    //}

                    return {
                        success: false,
                        message: message,
                    };
                }

                const currentDate = new Date();
                const expirationDate = new Date(data.expirationDate);

                if (currentDate > expirationDate) {
                    localStorage.removeItem('qrcodePixPayment');
                    return {
                        success: false,
                        message: 'O QRCode expirou'
                    };
                }

                if (data && data.type === 'pagseguro') {
                    setQrCode(data.qrCode)
                    setQrCodeText(data.qrCodeText)
                    verifyStatusQrcodePagseguro(data.orderId)

                    return {
                        success: true,
                        data: {},
                        msg: 'Existem dados no localStorage'
                    }
                } else if (data && data.type === 'wallet') {
                    setQrCode(data.qrCode)
                    setQrCodeText(data.qrCodeText)
                    const pluginspaceData = await getThisPluginspace();
                    const gatewayIdStorage = await getGatewayId();

                    verifyStatusQrcodeTotvs(
                        pluginspaceData ? pluginspaceData.id : 0,
                        gatewayIdStorage,
                        data.orderId,
                        data.processorTransactionId
                    )

                    return {
                        success: true,
                        data: {},
                        msg: 'Existem dados no localStorage'
                    }
                }
            }

            return {
                success: false,
                message: 'Não existem dados no localStorage'
            }

        } catch (error) {
            console.log(error)

            return {
                success: false,
                message: 'Não foi possível validar os dados'
            }
        }
    }


    async function verifyStatusQrcodePagseguro(orderId: string, customer?: CustomerType, amount?: number) {
        await api.get(`api/pagseguro/pagseguroConsultPix/${orderId}`,
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then(async (response) => {
                if (response.data && response.data.charges && response.data.charges[0] && response.data.charges[0].status === 'PAID') {
                    setLoading(true);
                    const pluginspaceData = await getThisPluginspace()
                    await api.post(`api/orders/processQueuePreOrderByTranscactionId/${orderId}`,
                        {},
                        {
                            headers: {
                                'Authorization': `Bearer ${await getToken()}`
                            }
                        }).then(async (response) => {
                            if (response.data && response.data.processed) {
                                const objProcessed = response.data.processed[0]

                                if (objProcessed) {
                                    if (objProcessed.update) {
                                        const orderData = objProcessed.data.data
                                        setOrderId(orderData.orderId);
                                        setOrderIdExt(orderData.orderidExt);
                                        setReceipt(orderData.customerReceipt.customer_receipt);

                                        await synchronizeContextToStorage();
                                        localStorage.removeItem("cupom");
                                        clearOrder();
                                        localStorage.removeItem('qrcodePixPayment');


                                        if (pluginspaceData?.type !== 'food') {
                                            navigate(`/${pluginspace_id}/new-success-order`);
                                        } else {
                                            navigate(`/${pluginspace_id}/success-order`);
                                        }

                                    } else {
                                        setLoading(false)
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Erro',
                                            text: 'Não foi possível finalizar sua compra',
                                        })
                                    }

                                } else {
                                    setLoading(false)
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Erro',
                                        text: 'Não foi possível finalizar sua compra',
                                    })
                                }

                            } else {
                                setLoading(false)
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Erro',
                                    text: 'Não foi possível finalizar sua compra',
                                })
                            }
                        })

                } else {

                    if (response.data &&
                        ((Object.keys(response.data.qr_codes[0]).includes('expiration_date') &&
                            new Date(response.data.qr_codes[0].expiration_date) < new Date()) ||
                            (response.data.charges && response.data.charges[0] &&
                                (response.data.charges[0].status === 'expired' ||
                                    response.data.charges[0].status === 'refunded' ||
                                    response.data.charges[0].status === 'DECLINED' ||
                                    response.data.charges[0].status === 'CANCELED')))) {
                        let status = !response.data.charges ? 'expired' : response.data.charges[0].status;
                        switch (status) {
                            case 'expired':
                                status = 'expirado';
                                break;
                            case 'refunded':
                                status = 'cancelado';
                                break;
                            case 'DECLINED':
                                status = 'cancelado';
                                break;
                            case 'CANCELED':
                                status = 'cancelado';
                                break;
                            default:
                                break;
                        }
                        const message = `QrCode está ${status}, não foi possível finalizar sua compra. Consulte na opção de pedidos mais informações, caso tenha efetuado o pagamento no banco`;
                        validateIfLocalStorage(!response.data.charges ? 'expired' : response.data.charges[0].status);
                        setLoading(false)

                        Swal.fire({
                            icon: 'warning',
                            title: 'Atenção',
                            text: message,
                            showCancelButton: true, // Adiciona o botão "Não"
                            confirmButtonText: 'Sim', // Texto para o botão "Sim"
                            cancelButtonText: 'Não', // Texto para o botão "Não"
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                try {
                                    // Usuário clicou em "Sim"
                                    await preOrderStatusCanceled(
                                        orderId,
                                        response.data.id,
                                        !response.data.charges ? 'expired' : response.data.charges[0].status
                                    );
                                    await getConfig(); // Aguarda a configuração após cancelar
                                } catch (error) {
                                    console.error('Erro ao processar:', error);
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Erro',
                                        text: 'Ocorreu um erro ao processar sua solicitação. Tente novamente.',
                                    });
                                }
                            } else if (result.isDismissed) {
                                // Usuário clicou em "Não" ou fechou o modal

                            }
                        });
                    }

                    setTimeoutItem(setTimeout(async () => {
                        await verifyStatusQrcodePagseguro(orderId, customer, amount)
                    }, 5000))
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    async function generateQrCodePagseguro(gatewayId: number, totalValue: number, customer: CustomerType) {
        //Valida a existência do plano de pagamento informado no contexto do pedido
        if (orderContext && !Object.keys(orderContext).includes('integrationPlan')) {
            //Não localizou plano de pagamento no contexto do pedido
            setLoading(false)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Não foi possivel obter plano de pagamento, entre em contato com a loja, ou escolha outra forma de pagamento',
            })
        }
        await api.get(`api/pluginconfig/${gatewayId}`,
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then(async (response) => {
                const pluginspaceData: void | PluginspaceResponseType = await getThisPluginspace();
                if (response.data.success && response.data.data && response.data.data[0] && pluginspaceData) {
                    const pluginconfig = response.data.data[0];
                    if (pluginconfig.plugintemplateId) {
                        await api.post(`api/pagseguro/generateQRCodePix`,
                            {
                                name: customer.name,
                                taxId: cpfCnpjNoMask(customer.cpf),
                                storeName: pluginspaceData.name,
                                pluginspaceId: pluginspaceData.id,
                                pluginconfigId: gatewayId,
                                amount: floatToCents(totalValue),
                                email: customer.email
                            },
                            {
                                headers: {
                                    'Authorization': `Bearer ${await getToken()}`
                                }
                            }).then(async (responsePagseguro) => {
                                if (responsePagseguro && responsePagseguro.data && responsePagseguro.data.qr_codes && responsePagseguro.data.qr_codes[0]) {
                                    const qrCodePagseguro = responsePagseguro.data.qr_codes[0];
                                    setQrCode((qrCodePagseguro.links && qrCodePagseguro.links[0] && qrCodePagseguro.links[0].href) ? qrCodePagseguro.links[0].href : '')
                                    setQrCodeText((qrCodePagseguro.text) ? qrCodePagseguro.text : '')
                                    setLoading(false)

                                    localStorage.setItem('qrcodePixPayment',
                                        JSON.stringify({
                                            type: 'pagseguro',
                                            qrCode: qrCodePagseguro.links[0].href,
                                            qrCodeText: qrCodePagseguro.text,
                                            orderId: responsePagseguro.data.id,
                                            expirationDate: qrCodePagseguro.expiration_date
                                        }))

                                    orderContext.gatewayId = gatewayId;
                                    orderContext.pix = true;

                                    await preOrderPix(orderContext, responsePagseguro.data);


                                    await verifyStatusQrcodePagseguro(responsePagseguro.data.id, customer, totalValue)
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Erro ao gerar QRCode!",
                                    }).then(() => navigate(-1))
                                }
                            })
                            .catch((err) => {
                                setLoading(false)
                                if (err && err.response && err.response.data && err.response.data.message) {
                                    let msgError = "Verifique a integração com a Pagseguro"
                                    if (err.response.data.message[0].includes("email")) {
                                        msgError = "Para pagamentos via PIX, é necessário informar o email do cliente"
                                    }
                                    Swal.fire({
                                        icon: "error",
                                        title: "Erro ao gerar QRCode!",
                                        text: msgError,
                                    }).then(() => navigate(-1))
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Erro ao gerar QRCode!",
                                        text: "Verifique a integração com a Pagseguro",
                                    }).then(() => navigate(-1))
                                }
                            })
                    }
                }
            })
            .catch((err) => {
                setLoading(false)
                Swal.fire({
                    icon: "error",
                    title: "Erro ao gerar QRCode!",
                    text: "Verifique a integração com a Pagseguro",
                }).then(() => navigate(-1))
            })
    }

    async function getConfig() {
        setLoadingHeader(true);
        setConfig(await getAppConfig());
        setLoadingHeader(false);
        await loadOrder();
    }

    //Teste - Persistência
    //Atualizar o processorTransactionId no LocalStore
    useEffect(() => {
        localStorage.setItem('processorTransactionId', JSON.stringify(processorTransactionId))
    })

    // //Carregar processorTransactionId do localStore
    // useEffect(() =>{
    //    if(localStorage.getItem('processorTransactionId')){
    //       setProcessorTransactionId(JSON.parse(localStorage.getItem('processorTransactionId')))
    //    }
    // },)
    // //fim teste

    return (
        <div className="qrcode-payment">
            <div className="content-qrcode-payment">
                {!loadingHeader && (
                    <Header
                        background={config?.webappcolor.backgroundheader ? config?.webappcolor.backgroundheader : '#F5F5F5'}
                        colorIcon={config?.webappcolor.iconsheader ? config.webappcolor.iconsheader : "#636363"}
                        logo={config?.icon ? config.icon : ''}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
                {loading ?
                    <div style={{ width: '100%', height: 'calc(100vh)' }}>
                        <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
                    </div>
                    :
                    <div className='order-qrcode-total'>
                        <div className="order-qrcode-body">
                            <h2>Pagamento PIX</h2>
                            <img src={qrCode} alt="QRCode" />
                            <div className="copy-qrcode">
                                <CopyToClipboard
                                    text={qrCodeText}
                                    onCopy={() => Swal.fire({
                                        icon: 'success',
                                        title: 'Texto copiado com sucesso!',
                                    })}>
                                    <MainButton
                                        color={config?.webappcolor.fontbutton ? config.webappcolor.fontbutton : '#636363'}
                                        backgroundColor={config?.webappcolor.webappbutton ? config.webappcolor.webappbutton : '#EAEAEA'}
                                        text='Copiar link QRCode'
                                    />
                                </CopyToClipboard>
                            </div>
                        </div>
                        <div className="qrcode-data">
                            <div className="row-data">
                                <p>Valor</p>
                                <p className='value'>{floatToPrice(total + freight)}</p>
                            </div>
                            <div className="row-data">
                                <p>Dados</p>
                                <p className='value'>Cliente: {name}</p>
                            </div>
                            <div className="row-data">
                                <p>Expira em</p>
                                <p className='value'>{datetimeToDatetimeBR(nowDate, { hour: -2 })}</p>
                            </div>
                        </div>
                        <div className="instruction-data">
                            <p className='instruction-text-data'>1. Acesse o aplicativo do seu banco.</p>
                            <p className='instruction-text-data'>2. Escolha a opção de pagamento com Pix, usando <strong>"Copia e Cola" ou lendo o QR Code.</strong></p>
                            <p className='instruction-text-data'>3. Copie o código Pix e cole no campo correspondente no aplicativo do seu banco, confirmando o pagamento.</p>
                            <p className='instruction-text-data'>4. <strong>Importante:</strong> Não feche esta tela ou navegador. Se necessário, apenas minimize o aplicativo para concluir o pagamento.</p>
                            <p className="instruction-text-data">5. Após o pagamento, você pode consultar o status do pedido acessando a opção <strong>Pedidos</strong> no menu.</p>
                        </div>
                        <div className="footer-button-qrcode-payment">
                            <MainButton
                                color={config?.webappcolor.fontbutton ? config.webappcolor.fontbutton : '#636363'}
                                backgroundColor={config?.webappcolor.webappbutton ? config.webappcolor.webappbutton : '#EAEAEA'}
                                text='Cancelar'
                                onClick={async () => {
                                    clearTimeout(timeoutItem);
                                    await validateIfLocalStorage('canceled');
                                    navigate(-1)
                                }}
                            />
                        </div>
                    </div>
                }
                {!loadingHeader && (
                    <Menu
                        activeMenu="cart"
                        fontColor={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        activeFontColor={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#000'}
                        backgroundMenu={config?.webappcolor.backgroundfooter ? config?.webappcolor.backgroundfooter : '#F5F5F5'}
                        colorIcons={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        highlightColorIcons={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#636363'}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
            </div>
        </div>
    )
}